
import { FolderPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog } from "@/components/ui/dialog";

interface CategoryActionButtonsProps {
  openNewCategoryForm: () => void;
  openMergeDialog: () => void;
  showNewCategoryForm: boolean;
  setShowNewCategoryForm: (show: boolean) => void;
}

const CategoryActionButtons = ({
  openNewCategoryForm,
  openMergeDialog,
  showNewCategoryForm,
  setShowNewCategoryForm
}: CategoryActionButtonsProps) => {
  return (
    <div className="flex items-center gap-2">
      <Dialog open={showNewCategoryForm} onOpenChange={setShowNewCategoryForm}>
        <Button className="flex items-center gap-2" onClick={openNewCategoryForm}>
          <FolderPlus className="h-4 w-4" />
          <span>New Category</span>
        </Button>
      </Dialog>
      
      <Button variant="outline" onClick={openMergeDialog}>
        Merge Categories
      </Button>
    </div>
  );
};

export default CategoryActionButtons;
